import { Injectable } from "@angular/core";
import { map, catchError } from "rxjs/operators";
import { APIBaseService } from "./api_base.service";
import { domain } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class MerchantAPI extends APIBaseService {
  namespace = "merchant";
  

  

  async requestTopUpCredit(data:any) {
    const url = `${domain}/${this.namespace}/requestTopUpCredit`;
    return this.http.post(url, data ,this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async requestTopUpPaynow(data:any) {
    const url = `${domain}/${this.namespace}/requestTopUpPaynow`;
    return this.http.post(url, data ,this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async queryTopUp(data:any) {
    const url = `${domain}/${this.namespace}/queryTopUp`;
    return this.http.post(url, data ,this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async merchantWalletBalance() {
    const url = `${domain}/${this.namespace}/merchantWalletBalance`;
    return this.http.get(url,this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async merchantWalleTranscation(json = {}) {
    const params = json || {};
    const options = { ...this.getHeader(), params };
    const url = `${domain}/${this.namespace}/merchantWalleTranscation`;
    return this.http.get(url,options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

 
}
